export default import.meta.ROLLDOWN_FILE_URL_pqV88wThNyZ88jn985tgAA